/**
 * Notification.ts - Notification Model
 * 
 * CHANGE HISTORY:
 * - 251021_0517 [8786ca9] danielbeer: feat: apply authr pattern to all 43 remaining packages
 * - 251021_0447 [ce7b5e6] danielbeer: feat: automate TypeScript and Actr integration for all packages
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import { generateId } from '@opcentral/core';


interface NotificationData {
  id?: string;
  userId?: any;
  title?: string;
  message?: string;
  type?: any;
  priority?: any;
  channels?: any;
  status?: any;
  read?: any;
  readAt?: any;
  data?: any;
}

export class Notification {
    id: string;
  userId?: string;
  title: string;
  message: string;
  type: any;
  priority: any;
  channels: any;
  status: any;
  read: any;
  readAt: any;
  data: unknown;
  actions: any;
  icon: any;
  url: string;
  createdAt: string;
  sentAt: any;
  deliveredAt: any;
  expiresAt: string;

  constructor(data: NotificationData = {}) {
    this.id = data.id || generateId();
    this.userId = data.userId;
    this.title = data.title;
    this.message = data.message;
    this.type = data.type || 'info'; // info, success, warning, error
    this.priority = data.priority || 'normal'; // low, normal, high, urgent
    this.channels = data.channels || ['in-app']; // email, sms, webhook, in-app, push
    this.status = data.status || 'pending'; // pending, sent, delivered, failed, read
    this.read = data.read || false;
    this.readAt = data.readAt || null;
    this.data = data.data || {}; // Additional data
    this.actions = data.actions || []; // Action buttons
    this.icon = data.icon || null;
    this.url = data.url || null;
    this.createdAt = data.createdAt || new Date().toISOString();
    this.sentAt = data.sentAt || null;
    this.deliveredAt = data.deliveredAt || null;
    this.expiresAt = data.expiresAt || null;
  }
  
  markAsRead(): any {
    this.read = true;
    this.readAt = new Date().toISOString();
    this.status = 'read';
  }
  
  markAsSent(): any {
    this.status = 'sent';
    this.sentAt = new Date().toISOString();
  }
  
  markAsDelivered(): any {
    this.status = 'delivered';
    this.deliveredAt = new Date().toISOString();
  }
  
  markAsFailed(): any {
    this.status = 'failed';
  }
  
  isExpired(): boolean {
    return this.expiresAt && new Date() > new Date(this.expiresAt);
  }
  
  toJSON(): NotificationData {
    return {
      id: this.id,
      userId: this.userId,
      title: this.title,
      message: this.message,
      type: this.type,
      priority: this.priority,
      channels: this.channels,
      status: this.status,
      read: this.read,
      readAt: this.readAt,
      data: this.data,
      actions: this.actions,
      icon: this.icon,
      url: this.url,
      createdAt: this.createdAt,
      sentAt: this.sentAt,
      deliveredAt: this.deliveredAt,
      expiresAt: this.expiresAt
    };
  }
  
  static fromJSON(json: NotificationData): Notification {
    return new Notification(json);
  }
}

export default Notification;
